export default __webpack_public_path__ + "static/media/incense2.27afd9c0.jpg";